import React from 'react';
import { Helmet } from 'react-helmet-async';
import Evaluations from './Evaluations';
import useRouter from '../../hooks/useRouter';
import PageHeading from '../../@communityshare/ui/PageHeading';
import Results from '../_common_results/Results';
import EvaluationProjectEducatorComplete from '../evaluations-project-educators-filtered/complete/Evaluation';
import EvaluationProjectEducatorPending from '../evaluations-project-educators-filtered/pending/Evaluation';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import MobileNavigation from '../evaluations/MobileNavigation';

export default function Layout(props) {
  const router = useRouter();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore Projects</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Evaluations', 'Projects: Educators']}
        title="All Evaluations"
        description={(
          <>
            Project evaluations sent to an educator.
          </>
        )}
      />
      <Evaluations router={router}>
        {function(result) {
          return (
            <Results result={result} columns={1} resource="evaluations" emptyIcon={ClipboardDocumentListIcon}>
              {function(evaluationProjectEducator) {
                if (evaluationProjectEducator.data.completed) {
                  return (
                    <EvaluationProjectEducatorComplete
                      key={evaluationProjectEducator.id}
                      evaluation={evaluationProjectEducator}
                    />
                  );
                }

                return (
                  <EvaluationProjectEducatorPending
                    key={evaluationProjectEducator.id}
                    evaluation={evaluationProjectEducator}
                  />
                );
              }}
            </Results>
          );
        }}
      </Evaluations>
    </div>
  );
}
